import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function RequireAdmin() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAF7F2]">
        <Loader2 className="h-6 w-6 animate-spin text-[#1E5F6E]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return <Outlet />;
}
